import { UserRole, UserPermission, Page, UserType } from '../enums'

type Cell = {
  exactClient: boolean,
  authenProvider?: UserType
  permissions: UserPermission[]
}

const Matrix: ReadonlyMap<Page, Cell> = new Map<Page, Cell>([
  [Page.HOME, { exactClient: false, permissions: [UserPermission.ADMIN, UserPermission.EXECUTOR] }],
  [Page.ADMIN, { exactClient: false, permissions: [UserPermission.ADMIN] }],
  [Page.ADMIN_CLIENTS, { exactClient: false, permissions: [UserPermission.ADMIN] }],
  [Page.ADMIN_SETTINGS, { exactClient: false, permissions: [] }],
  [Page.ADMIN_USERS, { exactClient: false, permissions: [] }],
  [Page.DASHBOARD, { exactClient: true, permissions: [UserPermission.ADMIN, UserPermission.EXECUTOR] }],
  [Page.DESTINATIONS, { exactClient: true, permissions: [UserPermission.ADMIN, UserPermission.EXECUTOR] }],
  [Page.JOBS, { exactClient: true, permissions: [UserPermission.ADMIN, UserPermission.EXECUTOR] }],
  [Page.JOB_MGNT, { exactClient: true, permissions: [UserPermission.ADMIN] }],
  [Page.SOURCES, { exactClient: true, permissions: [UserPermission.ADMIN, UserPermission.EXECUTOR] }],
  [Page.PROFILE_INFO, { exactClient: false, permissions: [UserPermission.ADMIN, UserPermission.EXECUTOR]}],
  [Page.PROFILE_PASSWORD, { 
    exactClient: false, 
    authenProvider: UserType.BUILTIN, 
    permissions: [UserPermission.ADMIN, UserPermission.EXECUTOR]
  }],
])

/**
 * User has a permission to access the page in working client
 * 
 * @param {IUser} user 
 * @param {string} clientId 
 * @param {Page} page 
 * @returns {boolean} 
 */
const isValidUser = (user: IUser, clientId: string, page: Page): boolean => {
  const cell = Matrix.get(page)

  if (!cell) {
    return false
  }

  if (cell.authenProvider && cell.authenProvider !== user.authenProvider) {
    return false
  }

  if (user.role === UserRole.SUPER_ADMIN) {
    return true
  }

  let [userPermission, keys] = [UserPermission.UN_ASSIGNED, Object.keys(user.permissions)]

  if (cell.exactClient) {
    userPermission = user.permissions[clientId] || UserPermission.UN_ASSIGNED
  } else if (keys.findIndex(key => user.permissions[key] === UserPermission.ADMIN) !== -1) {
    userPermission = UserPermission.ADMIN
  } else if (keys.length > 0) {
    userPermission = UserPermission.EXECUTOR
  }
  return cell.permissions.includes(userPermission)
}

export const accessMatrix = {
  isValidUser,
  Matrix
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/core/accessMatrix.ts